<div class="periods-row">
  <div class="resetter">
    @if (!isDefault()) {
      <span>{{ "Chart.Period" | translate }}</span>
      <span class="chart__select-reset" (click)="reset()">{{ "Chart.Reset" | translate }}</span>
    }
  </div>
  <div class="periods">
    @for (availablePeriod of availablePeriods; track $index) {
      <button (click)="setActivePeriod(availablePeriod)" [class.active]="activePeriod() === availablePeriod">
        {{ availablePeriod }}
      </button>
    }
  </div>
</div>
<div class="date-inputs">
  <div class="chart__select-wrapper">
    <input
      class="chart__input"
      type="text"
      id="startDate"
      mwlFlatpickr
      [enableTime]="true"
      [dateFormat]="'d-m-Y H:i'"
      [time24hr]="true"
      [convertModelValue]="true"
      [disableMobile]="true"
      [ngModel]="firstDate()"
      [prevArrow]="'<i></i>'"
      [nextArrow]="'<i></i>'"
      [maxDate]="tomorrow"
      (ngModelChange)="onFirstDateChange($event)"
    />
    <svg-icon class="chart__select-calendar-icon" src="assets/images/icons/select-calendar.svg"> </svg-icon>
  </div>
  <span class="chart__header-date-seperator">-</span>
  <div class="chart__select-wrapper">
    <input
      class="chart__input"
      type="text"
      mwlFlatpickr
      [enableTime]="true"
      [dateFormat]="'d-m-Y H:i'"
      [time24hr]="true"
      [convertModelValue]="true"
      [disableMobile]="true"
      [ngModel]="secondDate()"
      [maxDate]="tomorrow"
      (ngModelChange)="onSecondDateChange($event)"
    />
    <svg-icon class="chart__select-calendar-icon" src="assets/images/icons/select-calendar.svg"> </svg-icon>
  </div>
</div>
